import Vue from 'vue'
export default () => {
  const initialState = {
    detail: {
      idDocument: '',
      document: {
        cuil: '',
        tipo_documento: '',
        periodo: '',
        sector: '',
        locacion: '',
        estado: ''
      },
      sign: {
        fecha: '',
        tipo_firma: '',
        finger_print: ''
      },
      observation: [],
      dataFile: {
        id: '',
        nombre: '',
        fecha: '',
        origen: '',
        downloadName: '',
        ext: '',
        typeDocument: ''
      },
      dataUser: {
        fullname: '',
        entrydate: '',
        email: '',
        sector: '',
        location: '',
        countsigned: '',
        countunsigned: '',
        iduser: ''
      }
    }
  }
  const state = Vue.observable({
    ...initialState
  })
  return {
    reset() {
      state.detail = { ...initialState }
    },
    setDocumentDetail(document) {
      state.detail = { ...document }
    },
    state
  }
}
